import moment from 'moment';
import numeral from 'numeral'
import React from 'react'
import { tipoMovimiento, monedaSymbol } from '../data/catalogos';
import http from './http';
/**
 * returna una cadena en tipo capital
 * @param {String} string -  cadena de texto a covertir en Capital
 * @return {String} result
 */
const toCapital = string => [...string].map((c, i) => i == 0 ? c.toUpperCase() : c).join('');

const datetime = {
    today : () =>  new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
    now : () => new Date()
}
const currency ={
    1: 'C$',
    2: '$'
}
/**
 * Convierte un date a ticks
 * @param {Date} date -  cadena de texto a covertir en Capital
 */
const getTicks = date => ((date.getTime() * 10000) + 621355968000000000);

export const cellRender = currencyId =>  data => formatToMoney(data.value, currencyId || data.data.currencyId); 

export const cellRenderBold = currencyId => data => cellAsBold(formatToMoney(data.value, currencyId || data.data.currencyId));

export const formatId = value => numeral(value).format('000000');

export const dataFormatId = data => formatId(data.value);

export const formatIdValue = value => numeral(value).format('000000');

export const formatPad  = data => numeral(data.value).format('0,0.00');

export const formatNumberPhone = value => numeral(value).format('0000 0000');

export const formatToMoney = (value, currencyId) =>`${currency[currencyId || 2]} ${numeral(value).format('0,0.00')}`;

export const customizeTextAsPercent = data => `${data.value || 0} %`

export const cellAsBold = value => <b>{value}</b>;

export const cellAsPayoff = data => {    
    return <b>{data.value ? 'Pagada' : 'Pendiente'}</b>;
} 

export const cellDiff = data => {
    return(
        <div>
            <div className={data.data.tipo == tipoMovimiento.entrada ? 'count-entrada': 'count-salida'}>{data.data.existencias}</div>
        </div>
    )
}

export const toLower = text => String(text).toLocaleLowerCase();

const months = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic']
export const getMonthName = index => months[index-1]; 
export const customizeText = data => getMonthName(data.value);

export const phonePattern = /[-\s\./0-9]*$/g;
export const phoneRules = { X: /[0-9]/ };
export { getTicks, datetime }
export default toCapital


export const onCellPrepared = e => {

    const cellsQuantity = ['quantity', 'quantityRequest']
        
    if (e.rowType == 'data' && e.column.allowEditing) {
        if(cellsQuantity.includes(e.column.dataField))
            e.cellElement.classList.add('quantity-text');
        if(e.column.dataField == "quantityResponse")
            e.cellElement.classList.add('quantityResponse-text');
        if(e.column.dataField == "cost")
            e.cellElement.classList.add('cost-text');
        if(e.column.dataField == "price")
            e.cellElement.classList.add('price-text');
    }

}

export const formatDate = value => moment(value).format('DD/MM/YYYY')

export const obtenerTasaCambio  = date => {

    let v = new Date(moment(date).format());
    let ticks = getTicks(v);

    return http(`rates/get/${ticks}`).asGet();

}

export const padIdInfo = appInfo => value => numeral(value).format('0'.repeat(appInfo.customerPadding));

export const padIdInfoData = appInfo => data => numeral(data.value).format('0'.repeat(appInfo.customerPadding));

export const valueIsNullOrEmpty = value => (value == null || value == undefined || value == '');

export const valueHasAny = value => !valueIsNullOrEmpty(value);

export function case_insensitive_comp(strA, strB) {
    return strA.value.toLowerCase().localeCompare(strB.value.toLowerCase());
}